import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Home from "./components/Home";
import AIStudyAssistants from "./components/AIStudyAssistants";
import ExploreAICoursesnew from "./components/ExploreAiCoursesnew";

import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import ExploreYouTubeTools from "./components/ExploreYoutubeTools";
import AINoteTaking from "./components/AiNoteTaking";
import AIContentIdeas from "./components/AiContentIdeas";
import AIVideoEditing from "./components/AiVideoEditing";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/AIStudyAssistants" element={<AIStudyAssistants />} />
        <Route path="/exploreAICourses" element={<ExploreAICoursesnew />} />
        <Route path="/ExploreYouTubeTools" element={<ExploreYouTubeTools />} />
        <Route path="/AINoteTaking" element={<AINoteTaking />} />
        <Route path="/AIContentIdeas" element={<AIContentIdeas />} />
        <Route path="/AIVideoEditing" element={<AIVideoEditing />} />

      </Routes>
    </BrowserRouter>
  );
};

export default App;
